export default __webpack_public_path__ + "static/media/home-corporate-img-03.7e84c9a3.jpg";